import React, { FC } from 'react';
import { ToastContainer } from 'react-toastify';

const ToastsProvider: FC = () => (
  <ToastContainer toastClassName="cg-toast ui message" hideProgressBar={true} closeButton={false} autoClose={5000} />
);

export default ToastsProvider;
